// MUI
import { Paper, Box, Typography, IconButton, Button } from '@mui/material';
import { Close } from '@mui/icons-material';

// Hooks
import { useEffect } from 'react';

// context
import { useContext } from 'react';
import { DataContext } from "../../contexts/CartProvider";
import { SpentContext } from "../../contexts/SpentProvider";

// React Router
import { useNavigate } from 'react-router-dom';

export default function Home() {
    const navigate = useNavigate();

    const myContext = useContext(SpentContext);
    const { totalSpent } = myContext;

    const context = useContext(DataContext);

    const { items, setItems } = context;

    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(items));
    }, [items])

    function handleDeleteItem(deletedID) {
        setItems(items.filter(obj => obj.id !== deletedID));
    }

    let cartUI = items.map((ele) => {
        return (
            <Paper key={ele.id} sx={{ position: "relative", mt: "30px" }}>
                <Box sx={{ padding: "20px 45px", width: { xs: "250px", sm: "340px" }, gap: "20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="h6" color="inherit">{ele.item}</Typography>
                    <Typography variant="h6" color="inherit">${ele.price}</Typography>
                </Box>
                <IconButton sx={{ position: "absolute", right: "0", top: "0" }} onClick={() => {
                    handleDeleteItem(ele.id);
                }}>
                    <Close />
                </IconButton>
            </Paper>
        )
    })
    return (
        <Box>
            {cartUI}
            <Typography variant="h5" color="inherit" sx={{ textAlign: "center", mt: "30px" }}>Your Spend: ${totalSpent}</Typography>
            {
                totalSpent === 0 ? (
                    <Typography variant="h5" color="inherit" sx={{ textAlign: "center", mt: "30px" }}>
                        Go to <Button variant="outlined" onClick={() => {
                            navigate("/create");
                        }}>Create</Button> to Add Items
                    </Typography>
                ) : null
            }
        </Box>
    )
}